import React from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import { formatAmount, formatNegativeAmount } from 'src/utils/formatAmout';
import selectFormatDate from 'src/utils/selectDateFormat';
import dateFormatType from 'src/utils/dateFormatType';

const AccountingCapitalBalanceRow = ({
  period,
  rawDate,
  initialBalance,
  equipmentCost,
  initialPayment,
  monthlyPrincipal,
  contribution,
  residual,
  finalBalance
}) => {
  return (
    <TableRow hover>
      <TableCell align="center">{period}</TableCell>
      <TableCell align="center">
        {selectFormatDate(rawDate, dateFormatType.MONTH_AND_YEAR)}
      </TableCell>
      <TableCell align="center">{formatAmount(initialBalance)}</TableCell>
      <TableCell align="center">{formatAmount(equipmentCost)}</TableCell>
      <TableCell align="center">
        {formatNegativeAmount(initialPayment)}
      </TableCell>
      <TableCell align="center">
        {formatNegativeAmount(monthlyPrincipal)}
      </TableCell>
      <TableCell align="center">{formatNegativeAmount(contribution)}</TableCell>
      <TableCell align="center">{formatNegativeAmount(residual)}</TableCell>
      <TableCell align="center" sx={{ fontWeight: 'bold' }}>
        {formatAmount(finalBalance)}
      </TableCell>
    </TableRow>
  );
};

AccountingCapitalBalanceRow.propTypes = {
  period: PropTypes.number.isRequired,
  rawDate: PropTypes.string.isRequired,
  initialBalance: PropTypes.number.isRequired,
  equipmentCost: PropTypes.number,
  initialPayment: PropTypes.number,
  monthlyPrincipal: PropTypes.number,
  contribution: PropTypes.number,
  residual: PropTypes.number,
  finalBalance: PropTypes.number.isRequired
};

AccountingCapitalBalanceRow.defaultProps = {
  equipmentCost: 0,
  initialPayment: 0,
  monthlyPrincipal: 0,
  contribution: 0,
  residual: 0
};

export default AccountingCapitalBalanceRow;
